import {supportedAppVersion} from "../../helper/appInfo.js";
import {log} from "../../logging/logging.js";
import {LogName} from "../../logging/types/logname.js";
import {processAppConsentV2} from "@otto-ec/eprivacy-cmp";
import {getErrorMessage} from "../../helper/helper.js";
import {getConsentInformation} from "../data/consentInformationRepository.js";
import {ConsentProviderNotInitializedError} from "../data/types/ConsentProviderNotInitializedError.js";

export async function synchronizeConsentInformation() {
    if (!supportedAppVersion({android: "13.46.0", ios: "11.57.0"})) return

    const consentInformation = await getConsentInformation()
        .catch(error => {
            if (!(error instanceof ConsentProviderNotInitializedError)) {
                const message = "Error determining consent information:\n" + getErrorMessage(error)
                log(message, LogName.OneTrustJSON)
            }
        })

    if (consentInformation) {
        return processAppConsentV2(
            consentInformation.consentId,
            consentInformation.consentData,
            consentInformation.iabString
        ).then(wasSuccessful => {
            if (!wasSuccessful) throw new Error(
                "Return value was false!"
            );
        }).catch(error => {
            const message = "Error invoking processAppConsent at ePrivacy:\n" + getErrorMessage(error)
            log(message, LogName.OneTrustJavaScript)
        })
    }
}